import http from 'hub-http/clients/apiClient';
import { List } from 'immutable';
import Raven from 'raven-js';
import { registerQuery, useQuery } from 'data-fetching-client';
import { denormalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
export const AssociatedContactsQuery = registerQuery({
  fieldName: 'associatedContacts',
  args: ['objectId', 'objectTypeId', 'toObjectTypeName'],
  fetcher({
    objectId,
    objectTypeId,
    toObjectTypeName
  }) {
    return http.get(`associations/v1/associations/${objectTypeId}/${objectId}/associations-to/${toObjectTypeName}`).then(data => {
      return List(data.results.map(record => record.objectId));
    }).catch(error => {
      Raven.captureException(error, {
        fingerprint: ['ERROR_API_CONTACT_ASSOCIATION_FETCH_FAILED'],
        extra: {
          objectType: denormalizeTypeId(objectTypeId),
          objectId,
          toObjectType: toObjectTypeName
        }
      });
      throw error;
    });
  }
});
export function useAssociationsQuery({
  objectId,
  objectTypeId,
  toObjectTypeName,
  skip
}) {
  return useQuery(AssociatedContactsQuery, {
    variables: {
      objectId,
      objectTypeId,
      toObjectTypeName
    },
    skip
  });
}